import { render, staticRenderFns } from "./mzj_Nav.vue?vue&type=template&id=6ffb6cca&scoped=true&"
import script from "./mzj_Nav.vue?vue&type=script&lang=js&"
export * from "./mzj_Nav.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Nav.vue?vue&type=style&index=0&id=6ffb6cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb6cca",
  null
  
)

export default component.exports